import { render, staticRenderFns } from "./ruleGameContent.vue?vue&type=template&id=72ac85e5&scoped=true&"
import script from "./ruleGameContent.vue?vue&type=script&lang=js&"
export * from "./ruleGameContent.vue?vue&type=script&lang=js&"
import style0 from "./ruleGameContent.vue?vue&type=style&index=0&id=72ac85e5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac85e5",
  null
  
)

export default component.exports